<ng-container *ngIf="loading">
    <div class="interim">
        <div class="loading">
            <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!loading">
    <div class="dialog">
        <div class="header">
            <ng-container *ngIf="continue">
                <h3 mat-dialog-title>{{ "DIRECT_CONN.HEADER_LOADING" | translate}}</h3>
            </ng-container>
            <ng-container *ngIf="!continue">
                <h3 mat-dialog-title>{{ "DIRECT_CONN.HEADER_ERROR" | translate}}</h3>
            </ng-container>
            <p class="machinenr">{{ "DIRECT_CONN.NR" | translate}} {{machinenr}}</p>
        </div>
    
        <mat-dialog-content>
            <ng-container *ngIf="continue">
                <div class="loading">
                    <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
                </div>
            </ng-container>
        
            <ng-container *ngIf="!continue">
                <div class="error-content">
                    <div class="error">
                        {{ errorMessage | translate}}
                    </div>
                    <button mat-raised-button color="primary" class="btn" (click)="toMachineSelection()">{{ "DIRECT_CONN.BTN" | translate}}</button>
                </div>
            </ng-container>
        </mat-dialog-content>
    </div>
</ng-container>



